module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp12_5010.40e1c299.png";